import { camelizeKeys } from "humps";
import pick from "lodash/pick";
import { useCalendarRoot, useCalendarRootActions } from "PFApp/booking/store";
import { ProjectsResponse } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { WorkforceResponse } from "PFCore/hooks/queries/bookings/workforce/use_workforce_entries";
import { MetaWithPagination } from "PFTypes";
import { useEffect } from "react";

type UseCalendarRootMeta = {
  workforceData: WorkforceResponse | undefined;
  projectsData: ProjectsResponse | undefined;
};

export const useCalendarRootMeta = ({ workforceData, projectsData }: UseCalendarRootMeta) => {
  const calendarRoot = useCalendarRoot();
  const { setSelectedOrder, setTotalPages, setCounters, setAvailableOrderOptions } =
    useCalendarRootActions(calendarRoot);

  const updateMeta = (meta: MetaWithPagination) => {
    setTotalPages(meta.totalPages);
    setSelectedOrder(meta.order?.value ?? null);
    setAvailableOrderOptions(meta.order?.options ?? []);
  };

  useEffect(() => {
    if (workforceData) {
      const counters = pick(
        camelizeKeys(workforceData.meta.counters),
        "filteredProfilesCount",
        "filteredActiveProfilesCount",
        "endpointLimit"
      );
      setCounters(counters);
      updateMeta(workforceData.meta);
    }
  }, [workforceData]);

  useEffect(() => {
    if (projectsData) {
      const counters = pick(
        camelizeKeys(projectsData.meta.counters),
        "filteredActivitiesCount",
        "endpointLimit"
      );
      setCounters(counters);
      updateMeta(projectsData.meta);
    }
  }, [projectsData]);
};
